import type { ColumnDef } from '@tanstack/react-table';
import type { SageExportRow } from '../../services/sage.service';
import { formatCurrency } from '../../utils/money';

/** V1's confirmsageexportsearch layout (mas_cms.pl:4046), plus the family the filename
 *  encodes — which is the thing that decides what Mark Confirmed will stamp. */
export const confirmColumns: ColumnDef<SageExportRow>[] = [
  { accessorKey: 'fileid', header: 'File Name', size: 240 },
  { accessorKey: 'family', header: 'Type', size: 110 },
  { accessorKey: 'exportdatetime', header: 'Export Date', size: 170, meta: { isDate: true, showTime: true } },
  {
    accessorKey: 'confirmdatetime', header: 'Confirm Date', size: 170,
    meta: { isDate: true, showTime: true },
    cell: ({ row, getValue }) => (row.original.confirmed
      ? String(getValue() ?? '')
      : <span className="text-amber-600 dark:text-amber-400">Not confirmed</span>),
  },
  { accessorKey: 'recordcount', header: 'Total Records', size: 130, meta: { aggType: 'sum' } },
  {
    accessorKey: 'ttlamount', header: 'Total Amount', size: 150,
    cell: ({ getValue }) => formatCurrency(getValue()), meta: { aggType: 'sum' },
  },
  { accessorKey: 'deleted', header: 'Deleted', size: 90 },
];
